module.exports = __webpack_public_path__ + "static/courtesy_education02@2x-3ef3d3c47091ddc3b6b01723ddb8df65.png";